<template>
  <CCard v-if="!markLoading">
    <CCardHeader class="d-flex justify-content-between align-items-center">
      لیست دانش‌اموزان
    </CCardHeader>
    <CCardBody class="d-flex align-items-center text-center h-100">
      <CDataTable
          :fields="fields"
          :items="computedMarkList"
          :loading="loading"
          :noItemsView="{
          noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
        }"
          border
          class="w-100 d-flex justify-content-between h-100"
          fixed
          hover
          small
          striped
      >
        <template #addGrade="{ item }">
          <td>
            <CButton size="sm" square @click="onAddGradeModal(item)">
              <CIcon name="cil-pen"/>
            </CButton>
          </td>
        </template>
        <template #removeGrade="{ item }">
          <td>
            <CButton v-if="item.examMarkId" size="sm" square @click="onRemoveGradeModal(item)">
              <CIcon name="cil-trash"/>
            </CButton>
          </td>
        </template>
      </CDataTable>
      <AddGradeModal
          v-model="addGradeModal"
          :student="selectedItem"
          @get-mark="getMarkList"
          @get-exam="getExam"
      />
      <RemoveGradeModal
          v-model="removeGradeModal"
          :mark="selectedItem"
          @get-mark="getMarkList"
          @get-exam="getExam"
      />
    </CCardBody>
    <CCardFooter>
      <CButton class="px-5 py-2" color="primary" size="sm" square @click="onDownloadExcel">دریافت اکسل</CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";
import AddGradeModal from "../Modals/Exam/AddGradeModal.vue";
import RemoveGradeModal from "../Modals/Exam/RemoveGradeModal";

export default {
  components: {RemoveGradeModal, AddGradeModal},
  name: "MarkTable",
  props: {
    klassId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      markLoading: false,
      fields: [
        {key: "studentName", label: "نام"},
        {key: "studentLastname", label: "نام خانوادگی"},
        // { key: "examDate", label: "تاریخ پرسش" },
        {key: "examStringMark", label: "شاخص"},
        {key: "examPercent", label: "درصد"},
        {key: "examRank", label: "رتبه"},
        {key: "addGrade", label: "ثبت/ویرایش"},
        {key: "removeGrade", label: "حذف"},
      ],
      selectedItem: {},
      students: [],
      addGradeModal: false,
      removeGradeModal: false,
      markMap: null,
    };
  },
  computed: {
    computedMarkList() {
      return this.students.map((item) => {
        return {
          ...item,
          studentName: item.name,
          studentLastname: item.lastname,
          // examDate: this.markMap.has(item.id)
          //   ? this.markMap.get(item.id).exam.startDate.replaceAll("-", "/")
          //   : "",
          examStringMark: this.markMap.has(item.id)
              ? this.markMap.get(item.id).markString
              : "",
          examMark: this.markMap.has(item.id)
              ? this.markMap.get(item.id).mark
              : "",
          examMarkId: this.markMap.has(item.id)
              ? this.markMap.get(item.id).id
              : "",
          examPercent: this.markMap.has(item.id)
              ? this.markMap.get(item.id).percent
              : "",
          examRank: this.markMap.has(item.id)
              ? this.markMap.get(item.id).rank
              : "",
          markText: this.markMap.has(item.id)
              ? this.markMap.get(item.id).text
              : "",
        };
      });
    },
  },
  watch: {
    klassId(newValue) {
      if (newValue) {
        this.getStudents();
      }
    }
  },
  mounted() {
    this.getMarkList();
    this.getStudents();
  },
  methods: {
    async getMarkList() {
      try {
        this.markLoading = true;
        this.markMap = new Map();
        const {id: examId} = this.$route.params;
        const {data} = await axios.get("/mark", {
          params: {
            examId: examId,
          },
        });
        for (const i in data) {
          this.markMap.set(data[i].student.id, data[i]);
        }
      } catch (error) {
        console.log("errror", error);
      } finally {
        this.markLoading = false;
      }
    },
    async getStudents() {
      try {
        this.loading = true;
        const {data} = await axios.get(`/student?klassId=${this.klassId}`);
        this.students = data;
      } catch (error) {
        console.log("errror", error);
      } finally {
        this.loading = false;
      }
    },
    async onDownloadExcel() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const payload = [{
          key: 'examId',
          value: examId
        }]
        await axios
            .post('/report/7', payload)
            .then((response) => {
              window.open(response.data.url);
            });
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onAddGradeModal(item) {
      this.selectedItem = item;
      this.addGradeModal = true;
    },
    onRemoveGradeModal(item) {
      this.selectedItem = item;
      this.removeGradeModal = true;
    },
    getExam() {
      this.$emit('get-exam')
    }
  },
};
</script>

<style lang="scss" scoped></style>